import { render, staticRenderFns } from "./PremiumButton.vue?vue&type=template&id=0a3bb5b1&scoped=true&"
import script from "./PremiumButton.vue?vue&type=script&lang=ts&"
export * from "./PremiumButton.vue?vue&type=script&lang=ts&"
import style0 from "./PremiumButton.vue?vue&type=style&index=0&id=0a3bb5b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3bb5b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a3bb5b1', component.options)
    } else {
      api.reload('0a3bb5b1', component.options)
    }
    module.hot.accept("./PremiumButton.vue?vue&type=template&id=0a3bb5b1&scoped=true&", function () {
      api.rerender('0a3bb5b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/header/PremiumButton.vue"
export default component.exports